"use strict";
var unitas = unitas || {};
const modalIncluded = document.querySelector("#js-side-modal-included");
const modalGetOffer = document.querySelector("#js-side-modal-get-offer");
const darkOverlayElement = document.querySelector("#js-dark-overlay");
unitas.sidemodal =
  unitas.sidemodal ||
  (function () {
    function init() {}
    function showIncluded() {
      if (modalIncluded) {
        unitas.darkoverlay.show();
        modalIncluded.classList.add("side-modal--open");

        darkOverlayElement.addEventListener("click", function (e) {
          unitas.darkoverlay.hide();
          hideIncluded();
        });

        document.addEventListener("keydown", (evt) => {
          if (evt.key === "Escape") {
            unitas.darkoverlay.hide();
            hideIncluded();
          }
        });
      }
    }
    function hideIncluded() {
      if (modalIncluded) {
        unitas.darkoverlay.hide();
        modalIncluded.classList.remove("side-modal--open");
      }
    }
    function showGetOffer() {
      if (modalGetOffer) {
        unitas.darkoverlay.show();
        modalGetOffer.classList.add("side-modal--open");
      }

      darkOverlayElement.addEventListener("click", function (e) {
        unitas.darkoverlay.hide();
        hideGetOffer();
      });

      document.addEventListener("keydown", (evt) => {
        if (evt.key === "Escape") {
          unitas.darkoverlay.hide();
          hideGetOffer();
        }
      });
    }
    function hideGetOffer() {
      if (modalGetOffer) {
        unitas.darkoverlay.hide();
        modalGetOffer.classList.remove("side-modal--open");
      }
    }
    return {
      init: init,
      showIncluded: showIncluded,
      hideIncluded: hideIncluded,
      showGetOffer: showGetOffer,
      hideGetOffer: hideGetOffer,
    };
  })();
